module.exports = "@media (min-width: 320px) and (max-width: 479px) {\n  .marginTop {\n    margin-top: 120px !important; } }\n"